<script>
</script>

<span class="UITag">
	<slot />
</span>

<style global>
	.UITag {
		background: #666;
		color: #fff;
		line-height:1.7;
		padding: 0em 1em 0.2em;
		font-size: 1em;
		border-radius: 4px;
		display: -webkit-box;
    	-webkit-box-orient: vertical;
    	-webkit-line-clamp: 1;
		overflow: hidden;
		width: fit-content;
		max-width:85%;
		height: 1.8em;
	}
	.UICover .UITag {
		margin:0 auto;
		max-width:100%;
	}
</style>
